module.exports = __webpack_public_path__ + "media/images/front/icon_06_arrow_y-8620b254350c3279595696ef87d873ee.png";